function setupRActionFacebook() {
  ractionSetup($('#rfacebook'));
  $('#rfacebook form').submit(function () {
    $('#rfacebook button.js-submit').prop('disabled', true)
    $('#rfacebook .fa-spinner').show();
    $.post($(this).attr('action'), $(this).serialize()).done(function (data) {
      nextAction();
    }).fail(function (jqXHR) {
      $('#rfacebook').replaceWith(jqXHR.responseText)
    });
    return false;
  });

  $(".facebook-decision a").click(function(ev) {
    var btn = ev.target;
    btn.dataset.clicked = 'true';
    $(".js-submit").removeAttr("disabled");
    var all = $(btn).closest('.facebook-decision').siblings(":not([data-clicked='true'])");
    if (all.length == 0) {
      $("#rfacebook .js-submit").trigger('click');
    }

  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = setupRActionFacebook;